import { Routes, Route, Navigate } from 'react-router-dom';
import BookingPage from './pages/BookingPage';
import AdminPage from './pages/AdminPage';
import BookingConfirmation from './pages/BookingConfirmation';
import BookingManagePage from './pages/BookingManagePage';
import HaloIntegrationPage from './pages/HaloIntegrationPage';
import HaloDebugPage from './pages/HaloDebugPage';
import LoginPage from './pages/LoginPage';
import FormPage from './pages/FormPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Redirect home to booking page */}
        <Route path="/" element={<Navigate to="/book" replace />} />
        <Route path="/book/:linkId?" element={<BookingPage />} />
        <Route path="/bookings/:bookingId" element={<BookingConfirmation />} />
        <Route path="/bookings/:bookingId/manage" element={<BookingManagePage />} />

        {/* Auth route */}
        <Route path="/admin/login" element={<LoginPage />} />

        {/* Protected admin routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        {/* Public form page */}
        <Route path="/f/:formToken" element={<FormPage />} />

        {/* Halo integration - secured with integration key in URL */}
        <Route path="/halo/:integrationKey" element={<HaloIntegrationPage />} />
        <Route
          path="/halo-debug"
          element={
            <ProtectedRoute>
              <HaloDebugPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
